import React from "react";

import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <div className="layout__container">
        <div className="layout__wrapper">
          <img src="/images/decorum-icon.png" alt="Decorum Technology" />
          <h2>DECORUM TECHNOLOGY AND RESEARCH CENTER</h2>
          <h4>Software Development Training, 2022</h4>
          <hr />
        </div>
      </div>

      <Outlet />
    </>
  );
};

export default Layout;
